import {ReactNode} from 'react';
import {Popover, OverlayTrigger} from '@goproblems/ui';
import type {Placement} from '@goproblems/ui';

export const QuestionMarkPopover = ({
    title,
    content,
    className = '',
    placement = 'right',
    trigger = 'click',
}: {
    title: ReactNode;
    content: ReactNode;
    className?: string;
    placement?: Placement;
    trigger?: 'click' | 'hover';
}) => {
    return (
        <OverlayTrigger
            trigger={trigger === 'hover' ? ['hover', 'focus'] : 'click'}
            rootClose
            placement={placement}
            overlay={
                <Popover id="popover-status">
                    <Popover.Header>{title}</Popover.Header>
                    <Popover.Body>{content}</Popover.Body>
                </Popover>
            }>
            <i
                className={`fa-solid fa-circle-question text-muted opacity-60 ml-1 ${className}`}></i>
        </OverlayTrigger>
    );
};
